///import store from "../store";
//import firebase from "firebase";
import axios from "axios";
//import store from "../store";
import APIs from "../components/APIInit";
import store from "@/store";
import firebase from "firebase";
import "firebase/auth";
var pageOflineDatabaseRef;
export default {
    methods: {
        getLeaderboardScores(revisionNo) {
            return new Promise((resolve, reject) => {
                var instanceId = "OA_UAT";
                var clientId = "";
                var client = store.getters.getClient;
                if (client) {
                    clientId = client[0].id;
                }
                var eventId = store.getters.getEvent;
                var token = store.getters.getToken;
                let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + token,
                };
                let api =
                    APIs.GetLeaderboardScore +
                    "?iid=" + instanceId + "&cid=" + clientId + "&eid=" + eventId + "&rid=" + revisionNo;
                if (clientId && eventId && token) {
                    axios
                        .get(api, {
                            headers: headers,
                        })
                        .then(async (responseData) => {
                            //alert("then")
                            //debugger
                            var status = -1;
                            var statusCode = -1;
                            var message = "";
                            var myActionScores = [];
                            var leaderboardBadges = [];
                            //var leaderboardLeaderIDs = [];
                            var leaderboardLeaders = [];
                            var leaderboardGroups = [];
                            if (responseData && responseData.data) {
                                if (responseData.data.status != undefined) {
                                    status = responseData.data.status;
                                }
                                if (status == 0 && responseData.data.result) {
                                    var resultSet = responseData.data.result;

                                    if (
                                        resultSet.Achievements &&
                                        resultSet.Achievements.LeaderActions
                                    ) {
                                        resultSet.Achievements.LeaderActions.forEach((item) => {
                                            myActionScores.push(item);
                                        });
                                    }
                                    if (resultSet.Achievements && resultSet.Achievements.LeaderBadges && resultSet.Achievements.LeaderBadges.Badges) {
                                        resultSet.Achievements.LeaderBadges.Badges.forEach((item) => {
                                            leaderboardBadges.push(item);
                                        });
                                    }

                                    if (resultSet.Leaderboard && resultSet.Leaderboard.Leaders) {
                                        resultSet.Leaderboard.Leaders.forEach((item) => {
                                            //leaderboardLeaderIDs.push(item.UserID);
                                            leaderboardLeaders.push(item);
                                        });
                                    }
                                    if (
                                        resultSet.LeaderboardGroup &&
                                        resultSet.LeaderboardGroup.Groups
                                    ) {
                                        resultSet.LeaderboardGroup.Groups.forEach((item) => {
                                            leaderboardGroups.push(item);
                                        });
                                    }
                                    if (responseData.data.result.RevisionNo && responseData.data.result.RevisionNo > revisionNo) {
                                        revisionNo = responseData.data.result.RevisionNo;
                                    }
                                }
                                if (responseData.data.result && responseData.data.result.Response) {
                                    if (responseData.data.result.Response.StatusCode) {
                                        statusCode = responseData.data.result.Response.StatusCode;
                                    }
                                    if (responseData.data.result.Response.Message) {
                                        message = responseData.data.result.Response.Message;
                                    }
                                }
                            }
                            var result = {
                                data: {
                                    MyActionScores: myActionScores,
                                    LeaderboardBadges: leaderboardBadges,
                                    //LeaderboardLeaderIDs: leaderboardLeaderIDs,
                                    LeaderboardLeaders: leaderboardLeaders,
                                    LeaderboardGroups: leaderboardGroups,
                                    RevisionNo: revisionNo,
                                },
                                Message: message,
                                StatusCode: statusCode,
                                status: status,
                            };
                            resolve(result);
                        })
                        .catch(function (error) {
                            //console.error("Error on getLeaderboardScore: " + error);
                            reject({
                                data: {
                                    MyActionScores: [],
                                    LeaderboardBadges: [],
                                    //LeaderboardLeaderIDs: [],
                                    LeaderboardLeaders: [],
                                    LeaderboardGroups: [],
                                    RevisionNo: 0,
                                },
                                Message: error,
                                StatusCode: 0,
                                status: 0,
                            });
                        });
                } else {
                    reject({
                        Message: "Invalid Request",
                        StatusCode: 0,
                        status: 0,
                    });
                }
            });
        },
        getLeaderboardActions() {
            return new Promise((resolve, reject) => {
                var instanceId = "OA_UAT";
                var clientId = "";
                var client = store.getters.getClient;
                if (client) {
                    clientId = client[0].id;
                }
                var eventId = store.getters.getEvent;
                var token = store.getters.getToken;
                let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + token,
                };
                let requestData = {
                    key: {
                        clientId: clientId,
                        eventId: eventId,
                        instanceId: instanceId,
                    },
                };
                if (clientId && eventId && token) {
                    axios
                        .post(APIs.GetLeaderboardAction, requestData, { headers: headers, })
                        .then(async (responseData) => {
                            //debugger
                            //alert("then")
                            var status = -1;
                            var leaderboardActions = [];
                            if (responseData && responseData.data) {
                                if (responseData.data.status != undefined) {
                                    status = responseData.data.status;
                                }
                                if (status == 0 && responseData.data.results) {
                                    var resultSet = responseData.data.results;
                                    resultSet.forEach((item) => {
                                        leaderboardActions.push(item);
                                    });
                                }
                            }
                            var result = {
                                data: {
                                    LeaderboardActions: leaderboardActions
                                },
                                Message: "",
                                StatusCode: 0,
                                status: status,
                            };
                            resolve(result);
                        })
                        .catch(function (error) {
                            //console.error("Error on getLeaderboardActions: " + error);
                            reject({
                                data: {
                                    LeaderboardActions: [],
                                },
                                Message: error,
                                StatusCode: 0,
                                status: 0,
                            });
                        });
                } else {
                    reject({
                        Message: "Invalid Request",
                        StatusCode: 0,
                        status: 0,
                    });
                }
            });
        },
        postLeaderboardAction(actionTypeCode, docId) {
            //alert("postLeaderboardAction")
            return new Promise((resolve, reject) => {
                //debugger
                var instanceId = "OA_UAT";
                var clientId = "";
                var client = store.getters.getClient;
                if (client) {
                    clientId = client[0].id;
                }
                var eventId = store.getters.getEvent;
                var clientIP = store.getters.getClientIP;
                var token = store.getters.getToken;
                if (clientId && eventId && token && actionTypeCode) {
                    let headers = {
                        "content-type": "application/json",
                        Authorization: "Bearer " + token,
                    };
                    let requestData = {
                        key: {
                            clientId: clientId,
                            eventId: eventId,
                            instanceId: instanceId,
                        },
                        data: [{
                            actionTypeCode: actionTypeCode,
                            meta: {
                                callerIP: clientIP,
                                userAgent: navigator.userAgent
                            }
                        }]
                    };
                    if (docId) {
                        requestData.data[0].scavengeDocId = docId;
                    }
                    axios
                        .post(APIs.PostLeaderboardAction, requestData, { headers: headers, })
                        .then(async (responseData) => {
                            //debugger
                            //console.log(">>>>>>>" + responseData)
                            //alert("PostLeaderboardAction Success");
                            var status = [];
                            if (responseData && responseData.data && responseData.data.length > 0) {
                                var resultSet = responseData.data
                                resultSet.forEach((item) => {
                                    status.push(item);
                                });
                            }
                            var result = {
                                data: status,
                                Message: "",
                                StatusCode: 0,
                                status: 0,
                            };
                            resolve(result);
                        })
                        .catch(function (error) {
                            //alert("PostLeaderboardAction Failed");
                            //console.error("Error on getLeaderboardActions: " + error);
                            reject({
                                Message: error,
                                StatusCode: 0,
                                status: 0,
                            });
                        });
                } else {
                    reject({
                        Message: "Invalid Request",
                        StatusCode: 0,
                        status: 0,
                    });
                }
            });
        },
        insertPageWiseUserPresence(currentRouteName, previousRouteName, currentStatus, currenTimeStamp, previousTimeStamp, attachDisconnect) {
            console.log(previousTimeStamp);
            console.log(attachDisconnect);
            var event_collectionName = store.getters.getEventCollectionName;
            var userId = store.getters.getUser.id;
            firebase
                .database()
                .ref(event_collectionName)
                .child("pages")
                .child(currentRouteName)
                .child(userId)
                .once("value", (snapshot) => {
                    if (!snapshot.exists()) {
                        if (currentStatus) {
                            var insertProfile = {
                                [userId]: {
                                    'presence': {
                                        [currenTimeStamp]: currentStatus,
                                    },
                                    'profile': {
                                        'id': store.getters.getUser.id,
                                        'fname': store.getters.getUser.fname,
                                        'lname': store.getters.getUser.lname,
                                        'email': store.getters.getUser.Email,
                                        'name': store.getters.getUser.name,
                                        'profilepic': store.getters.getUser.profilepic,
                                        'company': store.getters.getUser.company,
                                        'title': store.getters.getUser.title
                                    }
                                    
                                }
                            };
                            firebase
                                .database()
                                .ref(event_collectionName + "/pages/" + currentRouteName)
                                .update(insertProfile)
                                .then(function () {
                                    //
                                });
                        } else {
                            firebase
                                .database()
                                .ref(event_collectionName + "/pages/" + currentRouteName + '/' + userId + '/presence')
                                .update({ [currenTimeStamp]: currentStatus })
                                .then(function () {
                                    //
                                });
                        }
                    } else {
                        if (currenTimeStamp) {
                            firebase
                                .database()
                                .ref(event_collectionName + "/pages/" + currentRouteName + '/' + userId + '/presence')
                                .update({ [currenTimeStamp]: currentStatus })
                                .then(function () {
                                    //
                                });
                        }
                    }
                    if (currenTimeStamp && previousRouteName) {
                        firebase
                            .database()
                            .ref(event_collectionName + "/pages/" + previousRouteName + '/' + userId + '/presence/' + currenTimeStamp)
                            .remove()
                            .then(function () {
                                //
                            });
                    }
                    if (pageOflineDatabaseRef) {
                        pageOflineDatabaseRef.onDisconnect().cancel();
                        pageOflineDatabaseRef = null;
                    }
                    if (currentRouteName && userId && currenTimeStamp) {
                        pageOflineDatabaseRef = firebase
                            .database()
                            .ref(event_collectionName + "/pages/" + currentRouteName + '/' + userId + '/presence' + '/' + currenTimeStamp);
                        firebase
                            .database()
                            .ref(".info/connected")
                            .on("value", function (snapshot) {
                                if (snapshot.val() == false) {
                                    return;
                                }
                                pageOflineDatabaseRef
                                    .onDisconnect()
                                    .remove()
                                    .then(function () {
                                        //
                                    });
                            });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }
}